import React, { useState, useEffect, useRef, useMemo } from "react";
import config from "../../Config";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import { useNavigate } from "react-router-dom";
import { NavLink, Link } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import FeeSystemMenu from "./FeeSystemMenu";
import BanksDropDown from "../Shared/BanksDropDown";
import moment from "moment";
import { Modal } from "react-bootstrap";
import { Form } from "react-bootstrap";
import { scrollToTop } from "../Shared/ScrollOnTop";
import * as XLSX from "xlsx";
import { set } from "lodash";

function AddBankScroll(props) {
  const [AccessKey, setAccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID, setUserID] = useState(localStorage.getItem("ID"));
  const [MemberType, setMemberType] = useState(
    localStorage.getItem("MemberType")
  );
  const [UserName, setUserName] = useState(localStorage.getItem("FullName"));
  const [isUpdated, setIsUpdated] = useState(false);
  const [loading, setLoading] = useState(false);
  const [listOfLedger, setLedger] = useState([]);
  const [TotalDeposited, setTotalDeposited] = useState("");
  const [ReceiptNo, SetReceiptNo] = useState("");
  const [ScrollDated, setScrollDated] = useState("");
  const [BenchNo, setBenchNo] = useState("");
  const [BarCodeValue, setBarCodeValue] = useState("");
  const [excelData, setExcelData] = useState([]);
  const [lgShow, setLgShow] = useState(false);

  const [Amount_Deposited, setAmount_Deposited] = useState("");
  const [RegistrationNo, setRegistrationNo] = useState("");
  const [ChallanNo, setChallanNo] = useState("");

  const [LateFeeFineStatus, setLateFeeFineStatus] = useState(false);
  const [LateFineAmount, setLateFineAmount] = useState(0);

  const [loadingPostEntries, setloadingPostEntries] = useState(false);
  const [LoadingFetchLedger, setLoadingFetchLedger] = useState(false);
  const [challanFetchPending, setChallanFetchPending] = useState(false);
  const [fileSelected, setfileSelected] = useState(false);
  const [loadingImport, setLoadingImport] = useState(false);

  const [selectedFileName, setSelectedFileName] = useState('');
  const [StudentADLedger, setStudentADLedger] = useState([]);
  const [enteredAmounts, setEnteredAmounts] = useState([]);
  const [totalAmount, setTotalAmount] = useState(0);
  const [selectedStudentID, setSelectedStudentID] = useState(0);
  const [StudentDepositedAmount, setStudentDepositedAmount] = useState(0);
  const [BankID, setBankID] = useState(0);
  const [mismatchedRegs, setMismatchedRegs] = useState([]);
  const [importErrors, setImportErrors] = useState([]);
  // pagination
  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(10000);
  const [totalRecords, setTotalRecords] = useState(0);
  const [loadAllFilters, setLoadAllFilters] = useState(false);
  const [sortField, setSortField] = useState("");
  const [sortDirection, setSortDirection] = useState("asc");

  const userGroupId = localStorage.getItem("User_Group_ID") || "";
  const canPostToLedger = userGroupId === "13" || userGroupId === "1";

  useEffect(() => {
    document.title = "Add Bank Scroll";
    setIsUpdated(false);
    setLoading(true);

    const data = {
      AccessKey: AccessKey,
      UserID: UserID,
      MemberType: MemberType,
      pageNo: pageNo,
      pageSize: pageSize,
      LoadAll: loadAllFilters,
      Dated: ScrollDated || "",
      BenchNo: loadAllFilters ? 0 : (parseInt(BenchNo, 10) || 0),
      AccountLevel: loadAllFilters ? 0 : (BankID || 0),
    };

    var api_config = {
      method: "post",
      url: config.base_url + "ScrollEntry/GetUnPostedEntries",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(api_config)
      .then(function (response) {
        ////console.log(response.data);
        setLedger(response.data.ListofRecords || []);
        setLoading(false);
        setTotalRecords(response.data.totalRecords);
        setTotalDeposited(response.data.TotalDeposited);
        setBankID((prev) => (prev && prev > 0 ? prev : response.data.BankID));
      })
      .catch(function (error) {
        //////console.log(error);
      });
  }, [pageNo, pageSize, isUpdated, ScrollDated, BenchNo, BankID, loadAllFilters]);

  const handlePageChange = (page) => {
    setPageNo(page);
  };

  const handleSort = (field) => {
    if (sortField === field) {
      setSortDirection((prev) => (prev === "asc" ? "desc" : "asc"));
    } else {
      setSortField(field);
      setSortDirection("asc");
    }
  };

  const getSortValue = (item, field) => {
    const val = item[field];
    if (field === "Dated") {
      return val ? new Date(val).getTime() : 0;
    }
    if (
      field === "Amount_Deposited" ||
      field === "Receipt_No" ||
      field === "BenchNumber"
    ) {
      const num = parseFloat(val);
      return Number.isFinite(num) ? num : 0;
    }
    return (val ?? "").toString().toLowerCase();
  };

  const sortedLedger = useMemo(() => {
    if (!sortField || !Array.isArray(listOfLedger)) {
      return listOfLedger;
    }
    return [...listOfLedger].sort((a, b) => {
      const aVal = getSortValue(a, sortField);
      const bVal = getSortValue(b, sortField);
      let cmp = 0;
      if (typeof aVal === "number" && typeof bVal === "number") {
        cmp = aVal - bVal;
      } else {
        cmp = String(aVal).localeCompare(String(bVal), undefined, {
          numeric: true,
          sensitivity: "base",
        });
      }
      return sortDirection === "asc" ? cmp : -cmp;
    });
  }, [listOfLedger, sortField, sortDirection]);

  const renderSortLabel = (field, label) => (
    <button
      type="button"
      className="btn btn-link p-0 text-decoration-none text-dark fw-semibold border-0"
      onClick={() => handleSort(field)}
      style={{ fontSize: "inherit" }}
    >
      {label}
      {sortField === field ? (
        <i
          className={`ri-arrow-${sortDirection === "asc" ? "up" : "down"}-s-line ms-1`}
        />
      ) : (
        <i className="ri-arrow-up-down-line ms-1 text-muted" style={{ opacity: 0.5 }} />
      )}
    </button>
  );

  const renderLedger = () => {
    if (Array.isArray(sortedLedger) && sortedLedger.length > 0) {
      let count = 1;
      return sortedLedger.map((item, index) => {
        return (
          <tr key={index}>
            <td>{count++ + pageSize * (pageNo - 1)} </td>
            <td>{item.Registration_No}</td>
            <td>{item.Student_Name}</td>
            <td>{item.Receipt_No}</td>
            <td>{item.BenchNumber}</td>
            <td>{moment(item.Dated).format("DD/MM/YYYY")}</td>
            <td className="text-center">{item.Amount_Deposited}</td>
            <td>{item.Challan_No}</td>
            {/* <td>{item.Balance_After_This_Entry}</td>
            <td>{item.Balance_Type_After_This_Entry}</td> */}
            <td className="text-center">
              <ul
                className="inline-action"
                aria-labelledby="dropdownMenuButton1"
              >
                <li>
                  <button
                    onClick={(e) => EditEntry(item.Challan_No, item.Amount_Deposited)}
                    className="green"
                  >
                    <i className="ri-edit-line"></i>
                  </button>
                </li>
                <li>
                  <button
                    onClick={(e) => deleteEntry(item.Entry_Id)}
                    className="red"
                  >
                    <i className="ri-delete-bin-line"></i>
                  </button>
                </li>
              </ul>
            </td>
          </tr>
        );
      });
    } else {
      return (
        <tr>
          <td colSpan="11">
            <h4
              className="mt-3"
              style={{ fontSize: "15px", color: "rgba(0,0,0,0.6)" }}
            >
              No Data Found
            </h4>
          </td>
        </tr>
      );
    }
  };
  const fetchChallanSummary = (challanNo) => {
    if (!challanNo) {
      toast.error("Please enter Challan No.", {
        position: toast.POSITION.TOP_RIGHT
      });
      return;
    }

    setChallanFetchPending(true);
    const data = {
      AccessKey: AccessKey,
      UserID: UserID,
      MemberType: MemberType,
      ChallanNo: challanNo,
    };

    var api_config = {
      method: "post",
      url: config.base_url + "ADLedger/GetChallanSummaryByNo",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(api_config)
      .then(function (response) {
        if (response.data.status_code == 1) {
          const dueAmount = parseFloat(response.data.Due_Date_Amount ?? 0);
          setAmount_Deposited(dueAmount);
          setRegistrationNo(response.data.Registration_No || "");
          setChallanNo(challanNo);
          setIsUpdated(true);
        } else {
          setAmount_Deposited("");
          setRegistrationNo("");
          toast.error(response.data.status_message, {
            position: toast.POSITION.TOP_RIGHT
          });
        }
        setIsUpdated(false);
        setChallanFetchPending(false);
      })
      .catch(function (error) {
        //////console.log(error);
        setAmount_Deposited("");
        setRegistrationNo("");
        setChallanFetchPending(false);
      });
  };

  const Code_to_Amount = () => {
    fetchChallanSummary(ChallanNo);
  };


  const deleteEntry = (ID) => {
    const result = window.confirm("Are you sure you want to delete?");

    if (result) {

      const data = {
        AccessKey: AccessKey,
        UserID: UserID,
        MemberType: MemberType,
        Entry_Id: ID,
      };

      var api_config = {
        method: "post",
        url: config.base_url + "ScrollEntry/DeleteScrollEntry",
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };

      axios(api_config)
        .then(function (response) {
          ////////console.log(response.data);
          if (response.data.status_code == 1) {
            setIsUpdated(true);
          }
          // setIsUpdated(false);
        })
        .catch(function (error) {
          //////console.log(error);
        });
    }
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    const reader = new FileReader();

    reader.onload = (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];
      const jsonData = XLSX.utils.sheet_to_json(sheet,
        {
          raw: false,
          dateNF: 'DD/MM/YYYY',
        }
      );
      setfileSelected(true);
      setExcelData(jsonData);
      setSelectedFileName(file.name); // Set the selected file name here
    };

    reader.readAsArrayBuffer(file);
  }

  const GetNextReceiptNo = (BenchNo) => {
    const data = {
      AccessKey: AccessKey,
      UserID: UserID,
      MemberType: MemberType,
      BenchNumber: BenchNo,
      Dated: ScrollDated,
    };
    ////////console.log(data);
    var api_config = {
      method: "post",
      url: config.base_url + "ScrollEntry/GetNextReceiptNumber",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(api_config)
      .then(function (response) {
        ////////console.log(response.data);
        if (response.data.status_code == 1) {
          setIsUpdated(true);
          SetReceiptNo(response.data.receiptNumber);
          setBenchNo(BenchNo);
        }
        // setIsUpdated(false);
      })
      .catch(function (error) {
        //////console.log(error);
      });
  };

  const ScanQRCode = (e) => {
    // if(e.target.value == 0) {
    //     setBarCodeValue("");
    // }
    // else {
    //     setBarCodeValue(e.target.value);
    // }

    setBarCodeValue(e.target.value);
  };

  useEffect(() => {
    const delay = setTimeout(() => {
      // Perform API call here
      if (BarCodeValue.length > 3) {
        postDataToAPI();
      } else {
        setBarCodeValue("");
      }
    }, 1000);

    window.scrollTo(0, document.body.scrollHeight);

    return () => clearTimeout(delay);
  }, [BarCodeValue]);

  const postDataToAPI = () => {
    if (BarCodeValue != "" || BarCodeValue.length > 3) {
      const [challan] = BarCodeValue.split(" ");
      setChallanNo(challan);
      fetchChallanSummary(challan);

      // const data = {
      //   UserID: UserID,
      //   AccessKey: AccessKey,
      //   BenchNumber: BenchNo,
      //   Dated: ScrollDated,
      //   RegistrationNo: reg,
      //   Receipt_No: ReceiptNo,
      //   Amount_Deposited: amount,
      //   LateFeeFine: LateFeeFineStatus,
      //   LateFineAmount: LateFineAmount,
      //   Bank_ID: BankID
      // };
      // var api_config = {
      //   method: "post",
      //   url: config.base_url + "ScrollEntry/AddScrollEntry",
      //   headers: {
      //     "Content-Type": "application/json",
      //   },
      //   data: data,
      // };

      // axios(api_config)
      //   .then(function (response) {
      //     //console.log(response.data);
      //     if (response.data.status_code == 1) {
      //       setIsUpdated(true);
      //       setBarCodeValue("");
      //       setRegistrationNo("");
      //       setAmount_Deposited("");
      //       SetReceiptNo(parseInt(ReceiptNo) + parseInt(1));

      //       if (response.data.RegistrationNo != "") {
      //         toast.success(
      //           "Student has been registered with Registration No " +
      //           response.data.RegistrationNo,
      //           {
      //             position: toast.POSITION.TOP_RIGHT,
      //           }
      //         );
      //       }
      //     }
      //     // setIsUpdated(false);
      //   })
      //   .catch(function (error) {
      //     //////console.log(error);
      //   });
    } else {
      //////console.log("here");
      // toast.error("Invalid QR code", {
      //     position: toast.POSITION.TOP_RIGHT
      // });
      setBarCodeValue("");
    }
  };
  const inputRef = useRef(null);

  const handleSubmit = () => {
    const challanToAdd = (ChallanNo || "").trim();
    if (challanToAdd && Array.isArray(listOfLedger)) {
      // Only the same receipt twice is a duplicate. A challan part-settled earlier (by an
      // advance adjustment, say) can legitimately take a second entry for the balance, so
      // the challan appearing in the list is not on its own a reason to refuse - the
      // server decides, and it checks the amount still outstanding.
      const sameReceipt = listOfLedger.some(
        (item) =>
          item &&
          String(item.Challan_No || "").trim().toLowerCase() ===
            challanToAdd.toLowerCase() &&
          String(item.Receipt_No || "").trim() === String(ReceiptNo || "").trim()
      );
      if (sameReceipt) {
        toast.error(
          `Receipt ${ReceiptNo} is already recorded against this challan in the list below.`,
          { position: toast.POSITION.TOP_RIGHT }
        );
        return;
      }
    }

    setBarCodeValue((ChallanNo || RegistrationNo) + " " + Amount_Deposited);
    setLoading(true);

    const data = {
      UserID: UserID,
      AccessKey: AccessKey,
      BenchNumber: BenchNo,
      Dated: ScrollDated,
      RegistrationNo: RegistrationNo,
      Challan_No: ChallanNo,
      Receipt_No: ReceiptNo,
      Amount_Deposited: Amount_Deposited,
      LateFeeFine: false,
      FineAmount: 0,
      Bank_ID: BankID,
      Serial_No: 0,
      Month: 0,
      Year: 0
    };

    //////console.log(data);

    var api_config = {
      method: "post",
      url: config.base_url + "ScrollEntry/AddScrollEntry",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(api_config)
      .then(function (response) {
        ////////console.log(response.data);
        if (response.data.status_code == 1) {
          setIsUpdated(true);
          setBarCodeValue("");
          SetReceiptNo(parseInt(ReceiptNo) + parseInt(1));
          setTimeout(() => inputRef.current?.focus(), 100);
        } else if (response.data.status_code == 0 || response.data.status_code == 2) {

          toast.error(response.data.status_message, {
            position: toast.POSITION.TOP_RIGHT
          });
          setLoading(false);
          setIsUpdated(false);

        }
        // setIsUpdated(false);
      })
      .catch(function (error) {
        //////console.log(error);
      });


    setAmount_Deposited("");
    setRegistrationNo("")
    setChallanNo("")
  };

  const handleSubmitByFile = async () => {
    if (!BankID || BankID <= 0) {
      toast.error("Please select Bank.", {
        position: toast.POSITION.TOP_RIGHT
      });
      return;
    }

    setLoadingImport(true);
    setImportErrors([]);
    const rows = excelData.map((row) => ({
      Serial_No: row.Serial_No || row.SERIAL_NO || row.SERIAL || "",
      Registration_No: row.Registration_No || row.REGISTRATION_NO || row.REGISTRATION || "",
      Challan_No: row.Challan_No || row.CHALLAN_NO || "",
      Amount: row.Amount || row.AMOUNT || "",
      Dated: row.Dated || row.DATED || "",
    }));

    try {
      const response = await axios({
        method: "post",
        url: config.base_url + "ScrollEntry/ImportScrollEntries",
        headers: {
          "Content-Type": "application/json",
        },
        data: {
          UserID: UserID,
          AccessKey: AccessKey,
          MemberType: MemberType,
          Bank_ID: BankID,
          BenchNumber: BenchNo,
          ReceiptStart: parseInt(ReceiptNo || 0),
          Rows: rows,
        },
      });

      if (response.data?.status_code === 1) {
        setIsUpdated(true);
        setBarCodeValue("");
        if (response.data.LastReceiptNo) {
          SetReceiptNo(response.data.LastReceiptNo.toString());
        }
        setMismatchedRegs(response.data.MismatchedRegs || []);
        setImportErrors(response.data.Errors || []);
      } else {
        toast.error(response.data?.status_message || "Import failed.", {
          position: toast.POSITION.TOP_RIGHT
        });
        setImportErrors(response.data?.Errors || []);
        setMismatchedRegs(response.data?.MismatchedRegs || []);
      }
    } catch (error) {
      //////console.log(error);
    }

    setLoadingImport(false);
  };
  const handleLateFee = (e) => {
    setLateFeeFineStatus(e.target.checked);

    if (e.target.checked === false) {
      setLateFineAmount(0);
    }
  };

  const PostEntries = () => {
    if (!canPostToLedger) return;
    if (loadAllFilters) {
      toast.error("Apply filters (date, bench, bank) to post entries.", {
        position: toast.POSITION.TOP_RIGHT
      });
      return;
    }
    if (TotalDeposited <= 0) {
      toast.error("Please Add Scroll of At Least 1 Student.", {
        position: toast.POSITION.TOP_RIGHT
      });
      return;
    }
    if (!ScrollDated || !BenchNo) {
      toast.error("Select date and bench number to post entries.", {
        position: toast.POSITION.TOP_RIGHT
      });
      return;
    }
    setloadingPostEntries(true);
    const data = {
      UserID: UserID,
      AccessKey: AccessKey,
      MemberType: MemberType,
      BenchNo: parseInt(BenchNo, 10) || 0,
      StartDate: ScrollDated,
      LateFeeFine: LateFeeFineStatus,
      LateFineAmount: LateFineAmount,
      ListofStudentLedger: enteredAmounts,
      AccountLevel: BankID || 0
    };

    var api_config = {
      method: "post",
      url: config.base_url + "ScrollEntry/PostEntriesIntoLedger",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(api_config)
      .then(function (response) {
        //console.log(response.data);
        if (response.data.status_code == 1) {
          setIsUpdated(true);
          toast.success(response.data.status_message, {
            position: toast.POSITION.TOP_RIGHT
          });
          setEnteredAmounts([]);
        }
        else {
          toast.error(response.data.status_message, {
            position: toast.POSITION.TOP_RIGHT
          });
        }
        setloadingPostEntries(false);
        setLgShow(false);
      })
      .catch(function (error) {
        //////console.log(error);
      });
  };

  const EditEntry = (challanNo, Amount) => {
    GetADLedgerByChallanNo(challanNo);
    setStudentDepositedAmount(Amount);
    setLgShow(true)
  }

  const GetADLedgerByChallanNo = (challanNo) => {
    setLoadingFetchLedger(true);
    const data = {
      AccessKey: AccessKey,
      UserID: UserID,
      MemberType: MemberType,
      ChallanNo: challanNo,
    };

    var api_config = {
      method: "post",
      url: config.base_url + "ADLedger/GetADLedgerByChallanNoForPayment",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(api_config)
      .then(function (response) {
        //console.log(response.data);
        if (response.data.status_code == 1) {
          setStudentADLedger(response.data.ListofRecords);
          const firstStudentId = response.data.ListofRecords?.[0]?.Student_ID || 0;
          setSelectedStudentID(firstStudentId);
          setLoadingFetchLedger(false)
        }
        else {
          setLoadingFetchLedger(false)
        }
      })
      .catch(function (error) {
        //////console.log(error);
        setLoadingFetchLedger(false)
      });
  }

  const TotalOfLedger = () => {
    let total = 0;

    StudentADLedger.forEach((item) => {
      total += parseFloat(item.PendingFee);
    });

    return total;
  };

  const handleAmountChange = (e, ID, PendingFee, Student_ID, FeeCode) => {
    let value = parseFloat(e.target.value);

    // Ensure value is within bounds
    if (value > PendingFee) {
      value = PendingFee;
      e.target.value = PendingFee;
    } else if (value < 0) {
      value = 0;
      e.target.value = 0;
    }

    setEnteredAmounts((prev = []) => {
      const updatedAmounts = [...prev];
      const existingIndex = updatedAmounts.findIndex((item) => item.ID === ID);

      if (existingIndex !== -1) {
        updatedAmounts[existingIndex] = { ID, value, Student_ID, PendingFee, FeeCode };
      } else {
        updatedAmounts.push({ ID, value, Student_ID, PendingFee, FeeCode });
      }

      return updatedAmounts;
    });
  };

  // console.log(enteredAmounts);

  const calculateTotalForStudent = (Student_ID) => {
    // Filter out the records that match the provided Student_ID and sum their values
    //console.log(Student_ID)
    const TotalAmount = Object.values(enteredAmounts)
      .filter((entry) => entry.Student_ID === Student_ID)
      .reduce((sum, entry) => sum + parseFloat(entry.value || 0), 0);
    if (StudentDepositedAmount < TotalAmount) {
      toast.error("Total Amount Should be Equal to Deposited Amount.", {
        position: toast.POSITION.TOP_RIGHT
      });
      return 0;
    }
    return TotalAmount;
  };


  return (
    <>
      <Modal
        size="lg"
        show={lgShow}
        onHide={() => setLgShow(false)}
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-modal-sizes-title-lg">
            Student Ledger
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>

          <div className="text-start mb-2 fw-bold">Amount Deposited: {StudentDepositedAmount}</div>
          <table className="table table-theme table-sm table-sticky ">
                    <thead>
              <tr>
                <th>Sr No</th>
                <th>Dated</th>
                <th>Fee Code</th>
                <th>Description</th>
                <th>Receiveable Fee</th>
                <th>Amount</th>
              </tr>
            </thead>
            <tbody>
              {LoadingFetchLedger == false ?
                <>


                  {StudentADLedger.map((item, index) => {

                    const existingAmount = enteredAmounts.find((entry) => entry.ID === item.ID);
                    return (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{moment(item.PostingDate).format("DD/MM/YYYY")}</td>
                        <td>{item.FeeCode}</td>
                        <td>{item.Description}</td>
                        <td>{item.PendingFee}</td>
                        <td>
                          <input
                            type="number"
                            value={existingAmount ? existingAmount.value : 0}
                            style={{ width: '100px' }}
                            max={item.PendingFee}
                            data-student-id={item.Student_ID}
                            className="form-control leaves text-center"
                            onChange={(e) => handleAmountChange(e, item.ID, item.PendingFee, item.Student_ID, item.FeeCode)}
                          />
                        </td>
                      </tr>
                    );
                  })}

                  <tr>
                    <td colSpan="4" className="text-start">Total:</td>
                    <td>{TotalOfLedger()}</td>
                    <td>{calculateTotalForStudent(selectedStudentID)}</td>
                  </tr>
                </>
                :


                <tr>
                  <td colSpan="10">
                    <div className="text-center">

                      <Spinner animation="border" role="status"></Spinner>
                    </div>
                  </td>
                </tr>
              }
            </tbody>
          </table>

          {loadingPostEntries ?
            <Spinner className="text-end" animation="border" role="status"></Spinner>
            :
            canPostToLedger && (
              <div className="text-end">
                <button
                  type="button"
                  onClick={PostEntries}
                  className="button button-primary"
                  disabled={loadAllFilters}
                  title={loadAllFilters ? "Apply filters to post entries" : ""}
                >
                  Post Entries in Ledger
                </button>
              </div>
            )
          }
        </Modal.Body>

      </Modal >

      <FeeSystemMenu />
      <ToastContainer />
      <div className="container body-content">
        <div className="page-head">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-6">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <NavLink to="/Dashboard">Dashboard</NavLink>
                    </li>
                    <li className="breadcrumb-item">
                      <NavLink to="/FeeSystem/FeeSystemDashboard">
                        Fee System
                      </NavLink>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Add BankScroll
                    </li>
                  </ol>
                </nav>
                <div className="page-title">Add BankScroll</div>
              </div>
            </div>
          </div>
        </div>
        <div className="page-content">
          <div className="container">
            <div>
              <div className="card mb-4">
                <div className="card-body">
                  <div className="row align-items-center">
                    <div className="col-md-2">
                      <div className="form-group">
                        <label >Branch:</label>
                        <input
                          type="text"
                          className="form-control"
                          value={UserName}
                          readOnly
                        />
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div className="form-check mt-4">
                        <input
                          className="form-check-input load-all-filters-cb"
                          type="checkbox"
                          id="LoadAllFilters"
                          checked={loadAllFilters}
                          onChange={(e) => {
                            setLoadAllFilters(e.target.checked);
                            setPageNo(1);
                          }}
                        />
                        <label className="form-check-label" htmlFor="LoadAllFilters">
                          Load all (ignore filters)
                        </label>
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div className="form-group">
                        <label>Dated:</label>
                        <input
                          type="date"
                          className="form-control"
                          value={ScrollDated}
                          onChange={(e) => {
                            setScrollDated(e.target.value);
                            setPageNo(1);
                          }}
                          max={moment().format(config.date_format_input)}
                        />
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div className="form-group">
                        <label> Bench No:</label>
                        <input
                          type="text"
                          className="form-control"
                          value={BenchNo}
                          onChange={(e) => {
                            const v = e.target.value;
                            setBenchNo(v);
                            setPageNo(1);
                            GetNextReceiptNo(v);
                          }}
                        />
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div className="form-group">
                        <label>Bank:</label>
                        <select
                          className="form-select"
                          value={BankID}
                          onChange={(e) => {
                            setBankID(parseInt(e.target.value || 0));
                            setPageNo(1);
                          }}
                        >
                          <option value="0">Please Select</option>
                          <BanksDropDown />
                        </select>
                      </div>
                    </div>
                    {/* <div className="col-md-2">
                      <div className="form-check mt-3">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="ChargeFine"
                          checked={LateFeeFineStatus}
                          onChange={(e) => handleLateFee(e)}
                        />
                        <label className="form-check-label" htmlFor="ChargeFine">
                          Struck Off Fine
                        </label>
                      </div>
                    </div>

                    {LateFeeFineStatus && (
                      <div className="col-md-2">
                        <div className="form-group">
                          <label> Fine Amount:</label>
                          <input
                            type="text"
                            className="form-control"
                            onChange={(e) => setLateFineAmount(e.target.value)}
                            required
                          />
                        </div>
                      </div>
                    )} */}
                  </div>
                </div>
              </div>
            </div>

            <div>
              <div className="card">
                <div className="card-body">
                  <table className="table table-theme table-sm table-sticky">
                    <thead>
                      <tr>
                        <th>S No</th>
                        <th>{renderSortLabel("Registration_No", "Registration No")}</th>
                        <th>{renderSortLabel("Student_Name", "Student Name")}</th>
                        <th>{renderSortLabel("Receipt_No", "Receipt No")}</th>
                        <th>{renderSortLabel("BenchNumber", "Bench No")}</th>
                        <th>{renderSortLabel("Dated", "Dated")}</th>
                        <th>{renderSortLabel("Amount_Deposited", "Amount Deposited")}</th>
                        <th>{renderSortLabel("Challan_No", "Challan No")}</th>
                        {/* <th>Balance After Entry</th> */}
                        {/* <th>Balance Type</th> */}
                        <th className="text-center">Action</th>
                      </tr>
                    </thead>
                    {renderLedger()}
                  </table>
                </div>
                <div className="card-footer text-end d-flex align-items-center justify-content-between">
                  <div>
                    <strong>{totalRecords}</strong> Records Found!
                  </div>
                  <div
                    className="d-flex align-items-center"
                    style={{ minHeight: "50px" }}
                  >
                    <h4 className="m-0 me-4">
                      Total Amount: <strong>{TotalDeposited}</strong>
                    </h4>
                    {loadingPostEntries ? (
                      <Spinner animation="border" role="status"></Spinner>
                    ) : canPostToLedger ? (
                      <button
                        type="button"
                        onClick={PostEntries}
                        className="button button-primary"
                        disabled={loadAllFilters}
                        title={loadAllFilters ? "Apply filters (date, bench, bank) to post entries" : ""}
                      >
                        Post Entries in Ledger
                      </button>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>

            <div className="card mt-2">
              <div className="card-body">
                <div className="row align-items-center gy-3">
                  <div className="col-md-2">
                    <div className="form-group">
                      <label>Receipt No:</label>
                      <input
                        type="text"
                        className="form-control"
                        onChange={(e) => SetReceiptNo(e.target.value)}
                        value={ReceiptNo}
                        required
                      />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group position-relative">
                      {loading ? (
                        <div
                          style={{
                            position: "absolute",
                            right: "20px",
                            top: "37px",
                          }}
                        >
                          <Spinner
                            animation="border"
                            size="sm"
                            role="status"
                          ></Spinner>
                        </div>
                      ) : (
                        ""
                      )}
                      <label>BarCode Entry:</label>
                      <input
                        ref={inputRef}
                        type="text"
                        className="form-control"
                        onChange={(e) => ScanQRCode(e)}
                        value={BarCodeValue}
                        disabled={ScrollDated == "" ? true : false}
                      />
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="form-group">
                      <label>Challan No:</label>
                      <input
                        type="text"
                        className="form-control"
                        value={ChallanNo}
                        onChange={(e) => setChallanNo(e.target.value)}
                        onBlur={(e) => {
                          const value = e.target.value?.trim();
                          if (value) {
                            fetchChallanSummary(value);
                          }
                        }}
                        name="ChallanNo"
                        required
                      />
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="form-group">
                      <label>Student Code:</label>
                      <input
                        type="text"
                        className="form-control"
                        value={RegistrationNo}
                        onChange={(e) => setRegistrationNo(e.target.value)}
                        name="RegistrationNo"
                        readOnly={ChallanNo !== ""}
                        required
                      />
                    </div>
                  </div>
                  <div className="col-md-1 tesx-center">
                    <div className="form-group">
                      <a
                        type="button"
                        onClick={Code_to_Amount}
                        className="print-icon text-center mt-4"
                      >
                        <span>
                          <i className="ri-arrow-left-right-line"></i>
                        </span>

                      </a>
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="form-group">
                      <label>Amount:</label>
                      <input
                        type="number"
                        className="form-control"
                        value={Amount_Deposited}
                        onChange={(e) => setAmount_Deposited(e.target.value)}
                        name="Amount_Deposited"
                        required
                      />
                    </div>
                  </div>

                  <div className="col-md-2 offset-md-4">
                    <button
                      type="button"
                      onClick={handleSubmit}
                      disabled={challanFetchPending || Amount_Deposited == "" || (RegistrationNo == "" && ChallanNo == "") || ScrollDated == "" || BenchNo == ""}
                      className={`button button-primary w-100
                       ${challanFetchPending || Amount_Deposited == "" || (RegistrationNo == "" && ChallanNo == "") || ScrollDated == "" || BenchNo == ""
                          ? "disabled"
                          : ""
                        }`}
                    >
                      Add Entry
                    </button>
                  </div>

                  {/* <div className="col-md-10  text-end">
                    <input
                      type="file"
                      accept=".xlsx, .xls"
                      onChange={handleFileChange}
                    />
                  </div> */}
                  <div className="col-md-10  text-end">
                    {selectedFileName && <span style={{ fontSize: "13px", marginRight: "10px" }}>Selected file: {selectedFileName}</span>}
                    <label htmlFor="chose-file" className="button button-white shadow-sm" style={{ cursor: "pointer" }}><i className="ri-upload-2-line"></i> Chose File
                      <input
                        className="" id="chose-file"
                        style={{
                          opacity: "0",
                          zIndex: "-1",
                          visibility: "hidden",
                          position: "absolute"
                        }}
                        type="file"
                        accept=".xlsx, .xls"
                        onChange={handleFileChange}
                      />
                    </label>
                  </div>
                  <div className="col-md-2">
                    <button
                      type="button"
                      onClick={handleSubmitByFile}
                      disabled={!fileSelected || loadingImport}
                      className={`button button-primary w-100
                       ${!fileSelected || loadingImport ? "disabled" : ""}`}
                    >
                      {loadingImport ? (
                        <span className="d-inline-flex align-items-center gap-2">
                          <Spinner animation="border" size="sm" role="status"></Spinner>
                          Processing...
                        </span>
                      ) : (
                        "Add Enteries"
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            {mismatchedRegs.length > 0 && (
              <div className="card mt-2">
                <div className="card-body">
                  <h6 className="mb-2">Amount mismatch with challan</h6>
                  <div style={{ fontSize: "13px" }}>
                    {mismatchedRegs.join(", ")}
                  </div>
                </div>
              </div>
            )}
            {importErrors.length > 0 && (
              <div className="card mt-2">
                <div className="card-body">
                  <h6 className="mb-2">Import Errors</h6>
                  <div style={{ fontSize: "13px" }}>
                    {importErrors.map((err, idx) => (
                      <div key={idx}>{err}</div>
                    ))}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default AddBankScroll;